import { useRef } from "react";
import HeadPage from "../../components/HeadPage/HeadPage";
import { fetchData } from "../../fetcher";
import TheMallOutletLayout from "../../layouts/TheMallOutletLayout/TheMallOutletLayout";
import WrapperDetail from "../../components/WrapperDetail/WrapperDetail";
import styles from "../../styles/pages/privacy-policy.module.scss";
import ScrollDown from "../../components/ScrollDown/ScrollDown";


const PrivacyPolicyContainer = ({ menuItems, dataContent }) => {
  const scrollToRef = useRef(null)

  return (
    <TheMallOutletLayout menuItems={menuItems}>
      <div id="head"><HeadPage {...dataContent.head} scrollToRef={scrollToRef} /></div>
      <div className={`centeredSection ${styles.WrapperDetail}`} ref={scrollToRef}>
        <WrapperDetail {...dataContent?.card.card} pastEvent />
      </div>
      <div className="scroll">
        <ScrollDown selector={scrollToRef} scrollTop />
      </div>
    </TheMallOutletLayout>
  );
};

PrivacyPolicyContainer.getInitialProps = async (context) => {
  let menuItems = null;
  let dataContent = null;
  const { slug } = context.query

  const resmenu = await fetchData("/init", context.query.locale)
  const data = await fetchData(slug, context.query.locale);

  if (resmenu) {
    menuItems = resmenu.menu;
  }

  if (data) {
    dataContent = data;
  }

  return {
    menuItems: menuItems,
    dataContent: dataContent
  }
}

export default PrivacyPolicyContainer;